module.exports = __webpack_public_path__ + "static/background-7bfc1911b23eb474f5572e1c572997a3.jpg";